/* eslint-disable max-len */
const before_auth_note = {
    field_type: 'note',
    predicate() {
        return this.setup && ! this.related_model.get('authenticated')
    },
    html: 'Meetings will be added to your Google calendar. To activate this spotlight, please connect your Google account and then set your hours of availability.',
}

const connect_button = {
    field_type: 'buttonset',
    predicate() {
        return ! this.related_model.get('authenticated')
    },
    buttons: [
        {
            type: 'button',
            className: 'connect-google-calendar button fullwidth dark primary xlarge',
            label: 'Connect Google Calendar',
            loading_label: 'Connecting…',
        },
    ],
}

const after_auth_note = {
    field_type: 'note',
    predicate() {
        return this.setup && this.related_model.get('authenticated')
    },
    html: 'Your Google account is connected. To activate this spotlight, please set your hours of availability.',
}

const edit_note = {
    field_type: 'note',
    predicate() {
        return ! this.setup && this.related_model.get('authenticated')
    },
    html: 'Meetings will be added to your Google calendar. Each appointment will include your page visitor’s name and email address.',
}

const reauth_note = {
    field_type: 'note',
    predicate() {
        return ! this.setup && ! this.related_model.get('authenticated')
    },
    html: 'Your Google authentication has expired and your Spotlight button is not connected. To re-activate this spotlight, please connect your Google account.',
}

const availability_button = {
    field_type: 'buttonset',
    predicate() {
        return this.related_model.get('authenticated')
    },
    buttons: [
        {
            type: 'button',
            className: 'set-availability button fullwidth dark primary xlarge glyph-angle-right-after',
            label: 'Set availability',
        },
    ],
}

const schedule_list = [
    {
        id: 'book_consultation_schedule',
        label: 'Book a consultation',
        glyph: 'hireme',
        description: 'Allow people to book a consultation with you from your page.',
        tweet_text(user) {
            return 'Book a consultation with me on my @aboutdotme page! 📅➡️'
        },
        fields: [
            before_auth_note,
            after_auth_note,
            edit_note,
            reauth_note,
            connect_button,
            availability_button,
        ],
    },
    {
        id: 'book_session',
        label: 'Book a session',
        glyph: 'calendar',
        description: 'Allow people to book a session with you from your page.',
        tweet_text(user) {
            return 'Book a session with me on my @aboutdotme page! 📅➡️'
        },
        fields: [
            before_auth_note,
            after_auth_note,
            edit_note,
            reauth_note,
            connect_button,
            availability_button,
        ],
    },
    {
        id: 'book_time',
        label: 'Book time with me',
        glyph: 'clock',
        default: true,
        description: 'Allow visitors to book a meeting with you from your page.',
        tweet_text(user) {
            return 'Book time with me on my @aboutdotme page! 📅➡️'
        },
        fields: [
            before_auth_note,
            after_auth_note,
            edit_note,
            reauth_note,
            connect_button,
            availability_button,
        ],
    },
    {
        id: 'let_meet',
        label: 'Let’s meet',
        glyph: 'chat',
        description: 'Allow visitors to book a meeting with you from your page.',
        tweet_text(user) {
            return 'Book time with me on my @aboutdotme page! 📅➡️'
        },
        fields: [
            before_auth_note,
            after_auth_note,
            edit_note,
            reauth_note,
            connect_button,
            availability_button,
        ],
    },
    {
        id: 'schedule_appt_pro',
        label: 'Schedule an appointment',
        glyph: 'calendar',
        description: 'Allow visitors to schedule an appointment with you from your page.',
        tweet_text(user) {
            return 'Schedule an appointment on my @aboutdotme page! 📅➡️'
        },
        fields: [
            before_auth_note,
            after_auth_note,
            edit_note,
            reauth_note,
            connect_button,
            availability_button,
        ],
    },
]

// assign schedule mechanism
// all spotlights in this list are premium
schedule_list.forEach(spotlight => {
    spotlight.is_premium = true
    spotlight.mechanism = 'schedule'
    spotlight.group = 'schedule'
})

module.exports = schedule_list
